import Roles from '@/auth/roles';
import i18n from '@/lang' // Internationalization
// import _ from 'underscore'
import historyFullStore from './tournament-history/tournament-history-full/tournament-history-full-store';
import historySingleStore from './tournament-history/tournament-history-single/tournament-history-single-store';
import tournamentModel from './tournament-model';
import tournamentPager from './tournament-pager';
import service from './tournament-service';
import categoryService from '../category/category-service';
import settingGroups from './setting-groups/setting-groups-store'; // NEW!!
import teamService from '../team/team-service';

// import playerService from '../player/player-service';
 /* eslint-disable */
export default {
  namespaced: true,

  modules: {
    historyFull: historyFullStore,
    historySingle: historySingleStore,
    settingGroups: settingGroups  // NEW!!
  },

  state: {
    loading: false,
    list: [],
    teamList: [],
    teamListGroupByCategory: {},
    pager: tournamentPager.build(),
    model: tournamentModel.default(),
    options: {},
  },

  getters: {
    loading: state => state.loading,
    list: state => state.list,
    teamList: state => state.teamList,
    teamListGroupByCategory: state => state.teamListGroupByCategory,
    pager: (state) => state.pager,
    model: state => state.model,
    options: state => state.options,
    hasRoleToUpdate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.tournamentEditor.id
      ]);
    },
    hasRoleToCreate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.tournamentEditor.id
      ]);
    },
    hasRoleToRead: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.tournamentViewer.id,
        roles.tournamentEditor.id
    ]);
    },
    hasRoleToReadLogs: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    },
    hasRoleToDelete: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.tournamentEditor.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    TEAM_LIST(state, payload) {
      state.teamList = payload || [];
    },

    TEAM_LIST_GROUP_BY_CATEGORY (state, payload) {
      state.teamListGroupByCategory = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload || tournamentModel.default();
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = tournamentPager.build();
      state.model = tournamentModel.default();
      state.options = {};
    },

    ADD_OPTIONS(state, payload) {
      state.options = Object.assign({}, state.options, { [payload.key]: payload.options });
    },
  },

  actions: {
    
    listTeams({ commit, dispatch, getters }) {
      commit('TEAM_LIST', []);
      commit('LOADING', true);
      
      return teamService
        .listByCategoryWithoutGroup()
        .then((teamListByCategory) => {
          commit('LOADING', false);
          commit('TEAM_LIST_GROUP_BY_CATEGORY', teamListByCategory)
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });

    },

    detail({ commit, dispatch }, id) {
      commit('LOADING', true);
     
      return service
        .find(id).then((model) => {
          
          if (!model || !model.id) {
            return Promise.reject(new Error('Not found'));
          }

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
      })
    },

    new({  commit, dispatch, rootGetters  }) {
      const tournament = rootGetters['entities/tournament/model']
      
      var model = { tournament:  tournament}
      
      commit('MODEL', model);
    },

    edit({ commit, dispatch }, id) {
      commit('LOADING', true);
     
      return service.find(id).then((model) => {
          if (!model || !model.id) {
            return Promise.reject(new Error('Not found'));
          }

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
        })
    },

    save({ getters, commit, rootGetters, dispatch }, tournament) {
      commit('LOADING', true);
      var modelToSave = getters.model

      if (tournament !== null ) {
        modelToSave = tournament
      } 
      return service
        .save(modelToSave, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.tournament.singular')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );

          commit('LOADING', false);
        })
      
    },

    destroy({ commit, dispatch, rootGetters }, model) {
      commit('LOADING', true);

      const tournament = rootGetters['entities/tournament/model']
      var modelToDestroy = model
      if (tournament.id !== null) {
        modelToDestroy = { ...model, tournament:  tournamentModel.forSimple(tournament)}
      }
            
      return service
        .destroy(modelToDestroy, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.tournament.singular')} ${i18n.t('notification.deletedSuccessfully')}`,
            { root: true }
          );
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    list({ commit, dispatch }) {
      commit('LIST', []);
      commit('LOADING', true);
      
      return service
        .list()
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },
    
    listByClubId({ commit, dispatch }, tournamentId) {
      commit('LIST', []);
      commit('LOADING', true);
      
      return service
        .listByClubId(tournamentId)
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    clear({ commit }) {
      commit('CLEAR');
    },

    loadOptions({ commit, dispatch }) {
      categoryService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'categories', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
      // playerService.listOptions().then((options) => {
      //   commit('ADD_OPTIONS', { key: 'players', options });
      // }).catch((error) => {
      //   dispatch('shared/error', error, { root: true });
      //   return Promise.reject(error);
      // });
    },
  },
};



// WEBPACK FOOTER //
// ./src/entities/tournament/tournament-store.js